import { setComponentTemplate } from '@ember/component';
import { hbs } from 'ember-cli-htmlbars';
import Component from '@glimmer/component';
import { getOwner } from '@ember/application';
import { getGlobalConfig } from '@embroider/macros';

var TEMPLATE = hbs("{{#in-element this.head insertBefore=null}}\n {{yield}}\n{{/in-element}}");

var inHead = setComponentTemplate(TEMPLATE, class extends Component {
  get head() {
    let document = getOwner(this).lookup('service:-document').documentElement;
    let child = document.firstChild;

    while (child) {
      if (child.tagName === 'HEAD') {
        return child;
      }

      child = child.nextSibling;
    }

    return undefined;
  }

  get inFastboot() {
    return getGlobalConfig().fastboot?.isRunning;
  }

});

export { inHead as default };
